import { Injectable } from '@angular/core';
import { Http } from 'src/app/shared/services/http.service';
import { HelpItem } from '../models/HelpItem';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HelpfulLinkService {
  constructor(private http: Http,
    private httpClient: HttpClient
  ) {}

  async getHelpfulLinks(lcType: string, excludeContent: boolean = false) {
    return this.http.get<HelpItem[]>(`/api/user/${lcType}/GetHelpfulLinks`, {
      queryParams: {
        excludeContent,
      },
      delay: excludeContent ? 1000 : 0,
    });
  }

  
  async downloadDocument(dcn: string, role: string) {
    return await lastValueFrom(
      this.httpClient.get(`/api/user/Document/${dcn}/${role}GetFaqDocument`, {
        responseType: 'blob',
        observe: 'response',
      })
    );
  }
}
